import { __makeTemplateObject } from "tslib";
import { css } from '@emotion/core';
import { color, spacing, border } from '@metro-ui/tokens/js';
export var variants = {
    primary: {
        color: color.inverted,
        bg: color.interaction,
        bgHover: color.palette.blue.shade[20],
    },
    secondary: {
        color: color.interaction,
        bg: color.palette.blue.tint[90],
        bgHover: color.palette.blue.tint[80],
    },
    danger: {
        color: color.inverted,
        bg: color.danger,
        bgHover: color.palette.red.shade[20],
    },
    outline: {
        color: color.interaction,
        bg: 'transparent',
        bgHover: color.interaction,
        colorHover: color.inverted,
    },
    outlineInverted: {
        color: color.inverted,
        bg: 'transparent',
        bgHover: color.inverted,
        colorHover: color.interaction,
    },
    tertiary: {
        color: color.interaction,
        bg: 'transparent',
        bgHover: color.palette.blue.tint[90],
        colorHover: color.interaction,
    },
};
export var actionButtonPadding = {
    label: spacing['x-small'],
    small: spacing['x-small'],
    medium: '0.625rem',
    large: spacing.small,
    'x-large': spacing.small,
};
export var iconSizeMap = {
    small: 16 / 24,
    medium: 1,
    large: 1,
    'x-large': 1.3333, // 32x32px
};
export var paddingSizeMap = {
    label: "0.25rem ".concat(spacing.medium),
    small: "0.375rem ".concat(spacing.medium),
    medium: "".concat(spacing['x-small'], " ").concat(spacing.medium),
    large: "".concat(spacing.small, " ").concat(spacing.medium),
    'x-large': "".concat(spacing.small, " ").concat(spacing.medium),
};
export var backgroundSizeMap = {
    label: '0.25rem',
    small: '0.375rem',
    medium: '0.375rem',
    large: '0.5rem',
    'x-large': '0.5rem',
};
export var buttonSizeToTextButtonSize = function (size) {
    switch (size) {
        case 'label':
        case 'small':
            return 'small';
        case 'large':
        case 'x-large':
            return 'large';
        default:
            return 'medium';
    }
};
export function variantStyles(variant) {
    var base = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      background-color: ", ";\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      background-color: ", ";\n    }\n  "])), variants[variant].color, variants[variant].bg, variants[variant].bgHover);
    switch (variant) {
        case 'outline':
        case 'outlineInverted':
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "\n        border-radius: ", ";\n        box-shadow: inset 0 0 0 ", "\n          ", ";\n\n        &:hover:not(:disabled),\n        &:focus:not(:disabled),\n        &:active:not(:disabled) {\n          color: ", ";\n        }\n      "], ["\n        ", "\n        border-radius: ", ";\n        box-shadow: inset 0 0 0 ", "\n          ", ";\n\n        &:hover:not(:disabled),\n        &:focus:not(:disabled),\n        &:active:not(:disabled) {\n          color: ", ";\n        }\n      "])), base, border.radius.medium, border.width.medium, variants[variant].bgHover, variants[variant].colorHover);
        default:
            return base;
    }
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=utils.js.map